import { ReactNode, useEffect, useRef, useState } from "react";
import ComplianceDialog from "./compliance-dialog";
import {
  acceptCompliance,
  hasAcceptedCompliance,
  subscribeToCompliance,
} from "./utils/compliance-session";

interface ComplianceGateProps {
  principal: string | undefined;
  children: ReactNode;
}

const ComplianceGate = ({ principal, children }: ComplianceGateProps) => {
  const [acceptance, setAcceptance] = useState(() => ({
    principal,
    accepted: hasAcceptedCompliance(principal),
  }));
  const memoryAcceptance = useRef<string | undefined | null>(null);

  useEffect(() => {
    memoryAcceptance.current = null;
    const refresh = (reset: boolean) => {
      if (reset) memoryAcceptance.current = null;
      setAcceptance({
        principal,
        accepted:
          memoryAcceptance.current === principal ||
          hasAcceptedCompliance(principal),
      });
    };
    const unsubscribe = subscribeToCompliance(refresh);
    refresh(false);
    return unsubscribe;
  }, [principal]);

  const proceed = () => {
    const persisted = acceptCompliance(principal);
    memoryAcceptance.current = persisted ? null : principal;
    setAcceptance({ principal, accepted: true });
  };

  return acceptance.principal === principal && acceptance.accepted ? (
    children
  ) : (
    <ComplianceDialog onProceed={proceed} />
  );
};

export default ComplianceGate;
